import {IBullhornFieldMeta} from '../interfaces/imetadata';
import {BullhornDataSpecialisationTypes} from './namespace-types/bullhorn-types';

export class BullhornFieldMeta {
  static mayContainHtml(field: IBullhornFieldMeta): boolean {
    return field.dataSpecialization === BullhornDataSpecialisationTypes.HTML;
  }
}
